export type PlayModePickerCopySettings = Record<string, unknown>;

export const PLAY_MODE_PICKER_COPY_DEFAULTS: PlayModePickerCopySettings = {
  sheet: {
    title: 'How are you playing?',
    subtitle: 'Choose versus, free-for-all, or solo.',
  },
  modes: {
    quick_play: {
      title: 'Versus',
      description: '2+ players. Build matchups across two sides, rotate players, and crown a winner.',
    },
    individuals: {
      title: 'Free-for-All',
      description: '3+ players. Everyone competes individually. No teams. One winner.',
    },
    teams: {
      title: 'Teams',
      description: 'Head-to-head games with fixed sides across rounds.',
    },
    score_challenge: {
      title: 'Solo',
      description: '1 player. Do your own run, set, or attempt and post the result.',
    },
    tournament: {
      title: 'Tournament',
      description: 'Bracket elimination for serious competition.',
    },
  },
  contexts: {
    styles: {
      workout: {
        sheet: { title: 'How are you training?' },
        modes: { score_challenge: { title: 'Solo Workout', description: 'Log your own workout and post the result.' } },
      },
      session: {
        sheet: { title: 'How are you playing?' },
        modes: { score_challenge: { title: 'Solo Session', description: 'Post your own result from this session.' } },
      },
      run: {
        sheet: { title: 'How are you running?' },
        modes: { score_challenge: { title: 'Solo Run', description: 'Log your own run and post the result.' } },
      },
    },
    sports: {
      weightlifting: {
        sheet: { title: 'How are you training?' },
        modes: { score_challenge: { title: 'Solo Workout', description: 'Log your own workout.' } },
      },
      skateboarding: {
        sheet: { title: 'How are you skating?', subtitle: 'Choose a head-to-head game, crew session, or solo line.' },
        modes: { score_challenge: { title: 'Solo Session', description: 'Log your own line or session.' } },
      },
    },
    variants: {},
  },
};
